import { PLATFORM } from 'core-lib/data/common';
import { checkMobileOS } from "core-lib/utils/helpers";

export enum NativeApps {
  GooglePay = 'googlepay',
  Phonepe = 'phonepe',
  Paytm = 'paytm',
  PaytmUpi = 'paytm_upi',
  CredUpi = 'cred_upi',
  GrowwUpi = 'groww_upi',
  JupiterUpi = 'jupiter_upi',
  AmazonUpi = 'amazon_upi',
  WhatsappUpi= 'whatsapp_upi',
  MobikwikUpi= 'mobikwik_upi',
  BhimUpi= 'bhim_upi',
  CredPay = 'cred_pay',
}

export const APP_INFO = {
  [NativeApps.GooglePay]: createAppData(NativeApps.GooglePay,"tez://upi/","com.google.android.apps.nbu.paisa.user"),
  [NativeApps.Phonepe]: createAppData(NativeApps.Phonepe,"phonepe://","com.phonepe.app"),
  [NativeApps.Paytm]: createAppData(NativeApps.Paytm,"paytmmp://upi/","net.one97.paytm"),
  [NativeApps.PaytmUpi]: createAppData(NativeApps.PaytmUpi,"paytmmp://upi/","net.one97.paytm"),
  [NativeApps.CredPay]: createAppData(NativeApps.CredPay,"credpay://","com.dreamplug.androidapp"),
  [NativeApps.CredUpi]: createAppData(NativeApps.CredUpi,"credpay://upi/","com.dreamplug.androidapp"),
  [NativeApps.JupiterUpi]: createAppData(NativeApps.JupiterUpi,"jupiter://upi/","money.jupiter"),
  [NativeApps.AmazonUpi]: createAppData(NativeApps.AmazonUpi,"amazontoalipay://upi/","in.amazon.mShop.android.shopping"),
  [NativeApps.GrowwUpi]: createAppData(NativeApps.GrowwUpi,null,"com.nextbillion.groww"),
  [NativeApps.WhatsappUpi]:createAppData(NativeApps.WhatsappUpi,null,"com.whatsapp"),
  [NativeApps.BhimUpi]: createAppData(NativeApps.BhimUpi,null,"in.org.npci.upiapp"),
  [NativeApps.MobikwikUpi]:createAppData(NativeApps.MobikwikUpi,null,"com.mobikwik_new"),
}

const intentsMap = {
  [NativeApps.CredPay]:getIntent(APP_INFO[NativeApps.CredPay].package_name,'credpay'),
  [NativeApps.GooglePay]:getIntent(APP_INFO[NativeApps.GooglePay].package_name),
  [NativeApps.CredUpi]:getIntent(APP_INFO[NativeApps.CredUpi].package_name),
  [NativeApps.Phonepe]:getIntent(APP_INFO[NativeApps.Phonepe].package_name),
  [NativeApps.Paytm]:getIntent(APP_INFO[NativeApps.Paytm].package_name),
  [NativeApps.PaytmUpi]:getIntent(APP_INFO[NativeApps.PaytmUpi].package_name),
  [NativeApps.JupiterUpi]:getIntent(APP_INFO[NativeApps.JupiterUpi].package_name),
  [NativeApps.AmazonUpi]:getIntent(APP_INFO[NativeApps.AmazonUpi].package_name),
  [NativeApps.GrowwUpi]:getIntent(APP_INFO[NativeApps.GrowwUpi].package_name),
  [NativeApps.WhatsappUpi]:getIntent(APP_INFO[NativeApps.WhatsappUpi].package_name),
  [NativeApps.BhimUpi]:getIntent(APP_INFO[NativeApps.BhimUpi].package_name),
  [NativeApps.MobikwikUpi]:getIntent(APP_INFO[NativeApps.MobikwikUpi].package_name)
}

// Helper function to generate platform-specific UPI app data
function createAppData(methodName:NativeApps, iosPackage=null,androidPackage:string) {
  return({
    //hack for paytm method
    method_name: methodName === NativeApps.Paytm ? NativeApps.PaytmUpi : methodName,
    package_name:{
      [PLATFORM.ios]:iosPackage,
      [PLATFORM.android]:androidPackage,
    }
  });
}

function getAndroidIntent(packageName: string,scheme='upi'){
  return `intent://{deepLink}#Intent;scheme=${scheme};package=${packageName};S.browser_fallback_url=https://play.google.com/store/apps/details?id=${packageName};end`;
}

function getIOSIntent(packageName: string) {return`${packageName}{deepLink}`}

function getIntent(packageName: { [key:string]: string },scheme='upi') {
  return ({
    [PLATFORM.ios]: getIOSIntent(packageName[PLATFORM.ios]),
    [PLATFORM.android]: getAndroidIntent(packageName[PLATFORM.android], scheme),
  })
}

export function getIntentString(intentString:string,methodName:string,prefix:string){
  const platform = checkMobileOS();
  if (platform !== PLATFORM.ios && platform !== PLATFORM.android) return null;

  let intent = null;

  if (intentString) {
    let deeplink = intentString;
    if (deeplink) deeplink = deeplink.replace(prefix, '');
    intent = intentsMap?.[methodName]?.[platform]
    if (intent) {
      intent = intent?.replace('{deepLink}', deeplink);
      if(methodName === NativeApps.JupiterUpi && platform === PLATFORM.ios){
        intent = customizeForJupiterUPIPayment(intent)
      }
      return intent;
    }
  }
  return null;
}

function customizeForJupiterUPIPayment(inputUrl:string) {
  let formattedUrl = inputUrl.replace(/pay\?/g, 'new-transaction?');
  const url = new URL(formattedUrl);

  url.searchParams.forEach((value, name) => {
    if (name === "am") {
      formattedUrl += `&amount=${value || ""}`;
    } else if (name === "pa") {
      formattedUrl += `&vpa=${value || ""}`;
    } else if (name === "pn") {
      formattedUrl += `&name=${value || ""}`;
    } else if (name === "tid") {
      formattedUrl += `&transactionId=${value || ""}`;
    } else if (name === "tr") {
      formattedUrl += `&merchantTransactionReference=${value || ""}`;
    } else if (name === "mc") {
      formattedUrl += `&mcc=${value || ""}`;
    } else if (name === "tn") {
      formattedUrl += `&remarks=${value || ""}`;
    } else if (name === "cu") {
      formattedUrl += `&currency=${value || ""}`;
    }
  });

  if (!url.searchParams.has("paymentType")) {
    formattedUrl += "&paymentType=intent";
  }

  if (!url.searchParams.has("type")) {
    formattedUrl += "&type=send";
  }

  return formattedUrl;
}





